module.exports = __webpack_public_path__ + "static/media/profileShadow.3c96b19e.png";